<!-- src/views/SmartChat.vue -->
<template>
    <div class="chat-container">
      <!-- 顶部返回栏（可选，提升移动端体验） -->
      <!-- <div class="chat-header">
        <span class="back-btn" @click="$router.back()">← 返回</span>
        <span class="title">智能问答</span>
      </div> -->
      <!-- iframe 主体 -->
      <iframe
        src="http://chatbi.jinghongda.net:1357/chat/e4ac67cd1be89c9d?mode=mobile"
        class="chat-iframe"
        frameborder="0"
        allow="microphone"
      ></iframe>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SmartChat'
  }
  </script>
  
  <style scoped>
  .chat-container {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #fff;
  }
  .chat-header {
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    border-bottom: 1px solid #eee;
    font-size: 16px;
    font-weight: bold;
  }
  .back-btn {
    margin-right: 15px;
    cursor: pointer;
    color: #1890ff;
  }
  .chat-iframe {
    flex: 1;
    width: 100%;
  }
  </style>